import React, { createContext, useContext, useState } from "react";
import translations from "../locals/translations.json";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  // Always default to English
  const [language, setLanguage] = useState("en");

  const translate = (key) => {
    try {
      const value = key
        .split(".")
        .reduce(
          (obj, k) => (obj && obj[k] !== undefined ? obj[k] : undefined),
          translations[language]
        );

      // If the value is an object (not a string), return the key to avoid rendering objects
      if (value && typeof value === "object" && !Array.isArray(value)) {
        return key;
      }
      return value ?? key;
    } catch {
      return key;
    }
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, translate }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};
